import React from 'react';
import { useLocation } from 'react-router-dom';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';

const ChatbotWidget = () => {
  const location = useLocation();

  // Direct messaging link to open Instagram DM conversation with @pingfence
  const instagramDmUrl = 'https://ig.me/m/pingfence';

  // Check if current page has a sticky mobile CTA bottom bar (Product Detail, Digital Bundle Detail)
  const hasBottomBar = 
    location.pathname.startsWith('/product/') || 
    location.pathname.startsWith('/digital-bundle/') ||
    location.pathname.startsWith('/course/');

  return (
    <aside aria-label="Instagram Chat Support">
      <a
        href={instagramDmUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Message @pingfence on Instagram"
        title="Message @pingfence on Instagram"
        className={`fixed right-4 sm:right-6 z-40 bg-primary hover:bg-black text-black hover:text-primary border-3 border-black p-3 sm:p-3.5 shadow-[4px_4px_0px_0px_#000000] hover:shadow-[6px_6px_0px_0px_#000000] hover:-translate-y-1 active:translate-y-0.5 active:shadow-none transition-all duration-300 flex items-center justify-center cursor-pointer group no-underline ${
          hasBottomBar
            ? 'bottom-[116px] sm:bottom-[124px] lg:bottom-8'
            : 'bottom-8 sm:bottom-10'
        }`}
      >
        <div className="relative flex items-center justify-center">
          <ChatBubbleLeftRightIcon className="h-6 w-6 sm:h-7 sm:w-7 stroke-[2.5] group-hover:scale-110 transition-transform" />
          <span className="absolute -top-1 -right-1 flex h-2.5 w-2.5" aria-hidden="true">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-black"></span>
          </span>
        </div>
      </a>
    </aside>
  );
};

export default ChatbotWidget;
